import { render, staticRenderFns } from "./ChatUser.vue?vue&type=template&id=5f2bd568&scoped=true"
import script from "./ChatUser.vue?vue&type=script&lang=js"
export * from "./ChatUser.vue?vue&type=script&lang=js"
import style0 from "./ChatUser.vue?vue&type=style&index=0&id=5f2bd568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bd568",
  null
  
)

export default component.exports